import usePreference from "@hooks/usePreference";
import { PropsWithClassName, cn } from "kz-ui-sdk";

interface TopBarBadgeProps extends PropsWithClassName {}

/**
 * Display top bar badge
 */
const TopBarBadge = ({ className }: TopBarBadgeProps) => {
  const { serverInfo } = usePreference();

  const topBarBadge = serverInfo?.theme?.topBarBadge;

  if (!topBarBadge?.visibility) return null;
  if (!topBarBadge?.imageUrl) return null;

  const badgeImage = (
    <img
      src={topBarBadge.imageUrl}
      alt="Top bar badge"
      className={cn("h-[30px] w-auto animate-fade-in rounded-[4px]", className)}
      decoding="async"
      loading="eager"
      aria-label="Top bar badge"
    />
  );

  if (topBarBadge.url) {
    return (
      <a
        href={topBarBadge.url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Top bar badge"
      >
        {badgeImage}
      </a>
    );
  }

  return badgeImage;
};

export default TopBarBadge;
